<script>
    // https://svelte.dev/docs#createEventDispatcher
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    import ProductOrders from "./ProductOrders.svelte";

    export let productsOrders;
    export let supplements = [];
    export let group = null;

let groupId = group ? group.id : -1;
</script>
{#if groupId== -1}
<h1>All products</h1>
{:else}
<h1>{group.name}</h1>
{/if}
<div class="product-orders">
    {#each productsOrders as productOrders}
        {#if productOrders.category == groupId || groupId == -1}
        <ProductOrders {productOrders}
            {supplements}
        />
        {/if}
    {:else}
    <p>loading....</p>
    {/each}
</div>
